/** @format */

/**
 * Use for checkbox groups with a maximum selection count: when the limit is
 * reached, options that are not selected should be disabled until the user
 * deselects one.
 */
export function isCheckboxDisabledAtMax(
  isSelected: boolean,
  selectedCount: number,
  maxSelection: number
): boolean {
  if (!Number.isFinite(maxSelection) || maxSelection <= 0) {
    return false;
  }
  return selectedCount >= maxSelection && !isSelected;
}
